import React, { useState } from 'react';
import { Dropdown, Modal, Button, Form } from 'react-bootstrap';
import navdots from '../../../Assets/images/navdots.svg'; 
import { formatDate } from '../../../Utils/Common';
import { Link } from 'react-router-dom';
import DeleteConfirmationModal from '../../ConfirmationModal';
import TokenService from "../../../Services/Token.service";
import ConfirmationModal from '../../ConfirmationModal';
import { useMediaQuery } from 'react-responsive';

const LabHolidayTableRow = ({ holiday,  handleDeleteUser}) => {

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = () => {
        handleDeleteUser(holiday.holiday_id);
        handleCloseDeleteModal(); 
    };

    const previousUrl = TokenService.getPrevLink();

    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <>
        {isMobile ? (
           <div className="admin-card-list">
          
             <div className="admin-card el-bg-table mb-2" >

               <div className="card-header">

               <div className="card-actions" style={{height:'10px'}}>
                <div style={{float:'right'}}>
                <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="el-action">
                                <Dropdown.Item as={Link} onClick={() =>{ TokenService.updatePrevLink('/admin/lab-hours');}} to={`/admin/lab-hours/lab-holiday/edit/${holiday.holiday_id}`} state={{ holiday }}>
                                    Edit
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleShowDeleteModal}>
                                    Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                 {/* <button className="btn btn-primary">View Details</button>
                 <button className="btn btn-warning" data-bs-toggle="modal" data-bs-target="#exampleModal">
                   Deactivate
                 </button>
                 <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#deleteuser">
                   Delete
                 </button> */}
               </div>


                 <h5>{holiday.name}</h5>
                 <p>{formatDate(holiday.from_date)} to {formatDate(holiday.to_date)}</p>
               </div>
                
               <div className=  {"card-body "} >
                 
                 <p><strong>Reason:</strong> {holiday.reason}</p>
                 
               </div>
          
             </div>
           
         </div>
         ):(<>
            <tr>
                <td>{holiday.name}</td>
                <td>{formatDate(holiday.from_date)} to {formatDate(holiday.to_date)}</td>
                <td>{holiday.reason}</td>                
                <td>
                    <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="el-action">
                                <Dropdown.Item as={Link} onClick={() =>{ TokenService.updatePrevLink('/admin/lab-hours');}} to={`/admin/lab-hours/lab-holiday/edit/${holiday.holiday_id}`} state={{ holiday }}>
                                    Edit
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleShowDeleteModal}>
                                    Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td>
            </tr>       
        </>)}
            <ConfirmationModal
            show={showDeleteModal}
            onHide={handleCloseDeleteModal}
            onConfirm={confirmDeleteUser}
            title="Confirm Delete"
            body="Are you sure you want to delete this vacation?"
            />

        </>
    );
}; 
export default LabHolidayTableRow;